export const notifications = '/notifications'